var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomepage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 37,
    viewBox: "0 0 50 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3F51",
    fillRule: "evenodd",
    d: "M36.393 33.19h9.505V15.387h-9.505V33.19zm11.08-20.954h-7.141V1.576C40.332.682 39.649 0 38.756 0H1.576C.682 0 0 .683 0 1.575v26.31c0 .893.683 1.576 1.575 1.576H18.59v3.676h-6.406c-.893 0-1.576.683-1.576 1.576 0 .892.683 1.575 1.576 1.575h15.912c.892 0 1.575-.683 1.575-1.575 0-.893-.683-1.576-1.575-1.576H21.74v-3.676h7.3c.893 0 1.575-.683 1.575-1.575 0-.893-.682-1.576-1.575-1.576H3.15V3.15h34.03v9.086h-2.363c-.893 0-1.576.683-1.576 1.575v20.954c0 .893.683 1.575 1.576 1.575h12.656c.892 0 1.575-.682 1.575-1.575V13.811c0-.892-.683-1.575-1.575-1.575z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepage);
export default __webpack_public_path__ + "static/media/homepage.d62ac2c1784940a6915c5dd2bfd3262c.svg";
export { ForwardRef as ReactComponent };